import { Component, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { loadTheme } from '../../store/action/theme.action';
import { selectColorPalette, selectFontStyles, selectFont, selectPrimaryColor, selectPrimaryColorPalette } from '../../store/selector/theme.selector';
import { ThemeState } from '../../store/model/theme.model';
import { ThemeInitializerService } from '../../utils/theme-initializer.service';

@Component({
  selector: 'app-theme-builder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-builder.component.html',
  styleUrls: ['./theme-builder.component.scss']
})
export class ThemeBuilderComponent {

  themeColors$!: Observable<ThemeState['colorPalette']>;
  fontStyle$!: Observable<ThemeState['fontStyles']>;
  selectedFont$!: Observable<ThemeState['font']>;
  selectedColor$!: Observable<ThemeState['primaryColor']>;
  selectedColorPalette$!: Observable<any>;
  constructor(private store: Store<{theme:ThemeState}>,private renderer: Renderer2,private themeService:ThemeInitializerService) {
  }

  ngOnInit():void{
    this.store.dispatch(loadTheme());

    this.themeColors$ = this.store.select(selectColorPalette);
    this.fontStyle$ = this.store.select(selectFontStyles);
    this.selectedFont$ = this.store.select(selectFont);
    this.selectedColor$ = this.store.select(selectPrimaryColor);
    this.selectedColorPalette$ = this.store.select(selectPrimaryColorPalette);
  }  



  seletPrimaryColor(e:string){   
    this.themeService.updateTheme({ primaryColor: e });
  }
  selectFont(e:string){   
    this.themeService.updateTheme({ font: e });
  }

}



